import { DateTime } from "luxon";
import I18n from '@/i18n'

export function isoDate(s) {
    return DateTime.fromISO(s, {zone: 'utc'})
}

export function parsedValid(s) {
    return DateTime.fromISO(s, {zone: 'utc'}).endOf('day').toMillis() >= DateTime.now().toMillis()
}

// Либо "1 месяц 4 дня", либо пустая строка если менее чем 1 день (ровно как и менее чем один день назад)!
export function distanceFromMillis(millis) {
    let now = DateTime.now().setZone('utc');
    let t = DateTime.fromMillis(millis);
    let diff = t.diff(now, ["years", "months", "days", "hours"]);
    let result = "";
    let y = Math.abs(diff.years);
    let m = Math.abs(diff.months);
    let d = Math.abs(diff.days);
    if (y > 0) {
        result += I18n.tc("license.y", y);
    }
    if (m > 0) {
        if (result.length) result += " ";
        result += I18n.tc("license.m", m);
    }
    if (d > 0) {
        if (result.length) result += " ";
        result += I18n.tc("license.d", d);
    }
    return result;
}

export function distanceFromParsed(s) {
    return distanceFromMillis(isoDate(s).toMillis())
}